import React from 'react'
import { useNavContext } from '../../context-api/nav-context'


const HomeIntro = () => {
  const {closeNavbarMenu} = useNavContext();
  return (
    <section className="intro" onMouseOver={closeNavbarMenu}>
        <div className="section-wrapper">
         <div className="content-container">
            <h2 className="title">We're a Plumbing and Heating Company Covering All Of Yorkshire</h2>
            <p className="subtitle">We maintain over 8000 properties 
            throughout Yorkshire with our reputable team of plumbing and heating engineers. 
            Whatever your heating and plumbing needs we're
             here to help you with...</p>
         </div>
        </div>
    </section>
  )
}

export default HomeIntro
